module.exports = __webpack_public_path__ + "static/drumster-caseimg-d1fef20523297f2e637e0e43f7df85c1.jpg";